const RAW_ASSETS_STATUSES: { [key: string]: string } = {
  PLANNED: 'planned',
  ACTIVE: 'active',
  PRE_AUCTION: 'preAuction',
  PAUSED: 'paused',
  LIVE_AUCTION: 'liveAuction',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  PLANNED_PRE_AUCTION: 'planned_preAuction',
  PLANNED_LIVE_AUCTION: 'planned_liveAuction'
};

const ASSETS_STATUSES: { [key: string]: string } = {
  [RAW_ASSETS_STATUSES.ACTIVE]: 'Offer submission',
  [RAW_ASSETS_STATUSES.PRE_AUCTION]: 'Offer submission',
  [RAW_ASSETS_STATUSES.PAUSED]: 'Paused',
  [RAW_ASSETS_STATUSES.LIVE_AUCTION]: 'Live-auction',
  [RAW_ASSETS_STATUSES.COMPLETED]: 'Completed',
  [RAW_ASSETS_STATUSES.CANCELLED]: 'Cancelled'
};

const ASSET_COLORS: { [key: string]: string } = {
  // Amber/Orange - Offer submission phase (warm, inviting)
  active: '#F59E0B',
  preAuction: '#F59E0B',
  // Cyan/Teal - Live auction (dynamic, energetic)
  liveAuction: '#06B6D4',
  // Amber with distinct styling - Paused state (attention-grabbing)
  paused: '#D97706',
  // Emerald - Completed (success, positive outcome)
  completed: '#10B981',
  // Rose/Red - Cancelled (clear warning state)
  cancelled: '#EF4444'
};

export { ASSET_COLORS, ASSETS_STATUSES, RAW_ASSETS_STATUSES };
